import { render, staticRenderFns } from "./users-search.vue?vue&type=template&id=6854cdfc&"
import script from "./users-search.vue?vue&type=script&lang=js&"
export * from "./users-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports